import { render, staticRenderFns } from "./V6SlideSchool.vue?vue&type=template&id=2f860ec4&scoped=true&"
import script from "./V6SlideSchool.vue?vue&type=script&lang=js&"
export * from "./V6SlideSchool.vue?vue&type=script&lang=js&"
import style0 from "./V6SlideSchool.vue?vue&type=style&index=0&id=2f860ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f860ec4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
